<template>
<div class="chapter">
<div class="inner_page">
<p class="sectiontop" style="text-align:center;"><i>Heaven has no rage like love to hatred turned,<br/>
  Nor hell a fury like a woman scorned</i>.</p>
<p class="first" style="text-align:center;">—William Congreve, 1670–1729</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_fm03.vue?4a62055c